import React from "react";
import { Helmet } from "react-helmet-async";
import metaDescriptions from "./staticMetaDescriptions";

const BASE_URL = "https://mhcockpit.com";

const Metadescription = ({ pageLink }) => {
  const rawPath = pageLink || (typeof window !== "undefined" ? window.location.pathname : "/");
  // Normalize path: strip trailing slash unless root
  const cleanPath = rawPath.length > 1 ? rawPath.replace(/\/+$/, "") : rawPath;

  // Skip dynamic blog detail pages handled by dedicated API SEO wrapper
  // (/blogs/education-loan-emi-calculator is a static route with dedicated metadata)
  if (
    cleanPath.startsWith("/blogs/") &&
    cleanPath !== "/blogs" &&
    cleanPath !== "/blogs/education-loan-emi-calculator"
  ) {
    return null;
  }

  const data = metaDescriptions[cleanPath] || metaDescriptions[rawPath];

  const defaultCanonical = `${BASE_URL}${cleanPath === "/" ? "" : cleanPath}`;
  const canonicalUrl = data?.canonicalUrl || defaultCanonical;

  const meta = {
    title: data?.title || "MH Cockpit | Pilot Training & top UGC Aviation College in India",
    description:
      data?.description ||
      "MH Cockpit offers CPL and pilot training alongside BSc, BBA, and MBA Aviation at top UGC-approved Aviation colleges across India. DGCA-aligned curriculum.",
    keywords: data?.keywords || "aviation college, pilot training, aviation courses",
    canonicalUrl: canonicalUrl,
    robots: data?.robots
      ? (data.robots.includes("max-snippet") ? data.robots : `${data.robots}, max-snippet:-1, max-image-preview:large`)
      : "index, follow, max-snippet:-1, max-image-preview:large",
    ogTitle: data?.ogTitle || data?.title || "MH Cockpit | Pilot Training & top UGC Aviation College in India",
    ogDescription:
      data?.ogDescription ||
      data?.description ||
      "MH Cockpit offers CPL and pilot training alongside BSc, BBA, and MBA Aviation at top UGC-approved Aviation colleges across India.",
    ogUrl: data?.ogUrl || canonicalUrl,
    ogType: data?.ogType || "website",
    ogSiteName: data?.ogSiteName || "MH Cockpit",
    ogImage:
      data?.ogImage ||
      "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    ogImageWidth: data?.ogImageWidth ? String(data.ogImageWidth) : "1920",
    ogImageHeight: data?.ogImageHeight ? String(data.ogImageHeight) : "1080",
    twitterCard: data?.twitterCard || "summary_large_image",
    twitterTitle: data?.twitterTitle || data?.ogTitle || data?.title || "MH Cockpit",
    twitterDescription:
      data?.twitterDescription ||
      data?.ogDescription ||
      data?.description ||
      "MH Cockpit Aviation Training",
    twitterImage:
      data?.twitterImage ||
      data?.ogImage ||
      "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
  };

  return (
    <Helmet>
      {meta.title && <title>{meta.title}</title>}
      {meta.title && <meta name="title" content={meta.title} />}
      {meta.description && <meta name="description" content={meta.description} />}
      {meta.keywords && <meta name="keywords" content={meta.keywords} />}
      <link rel="canonical" href={meta.canonicalUrl} />
      <meta name="robots" content={meta.robots} />
      <meta httpEquiv="X-Robots-Tag" content={meta.robots} />

      {/* Preload Critical Hero Image only on Homepage */}
      {cleanPath === "/" && (
        <link
          rel="preload"
          as="image"
          href="https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
          type="image/webp"
        />
      )}

      {/* Open Graph */}
      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:url" content={meta.ogUrl} />
      <meta property="og:type" content={meta.ogType} />
      {meta.ogSiteName && <meta property="og:site_name" content={meta.ogSiteName} />}
      {meta.ogImage && <meta property="og:image" content={meta.ogImage} />}
      {meta.ogImageWidth && <meta property="og:image:width" content={meta.ogImageWidth} />}
      {meta.ogImageHeight && <meta property="og:image:height" content={meta.ogImageHeight} />}

      {/* Twitter */}
      <meta name="twitter:card" content={meta.twitterCard} />
      <meta name="twitter:title" content={meta.twitterTitle} />
      <meta name="twitter:description" content={meta.twitterDescription} />
      {meta.twitterImage && <meta name="twitter:image" content={meta.twitterImage} />}
    </Helmet>
  );
};

export default Metadescription;
